import { useEffect, useState } from "react";
import { resolveRedirectPath } from "../common/redirects";
import { getDocumentMetadata } from "./getDocumentMetadata";

export function useManageDocumentMetadata(url: string) {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  useEffect(() => {
    if (isHydrated) {
      const { title, description, keywords, noIndex } = getDocumentMetadata(url);

      document.title = title;

      let titleMeta = document.querySelector<HTMLMetaElement>(
        'meta[name="title"]',
      );

      if (!titleMeta) {
        titleMeta = document.createElement("meta");
        titleMeta.name = "title";
        document.head.appendChild(titleMeta);
      }

      titleMeta.setAttribute("content", title);

      let meta = document.querySelector<HTMLMetaElement>(
        'meta[name="description"]',
      );

      if (description) {
        if (!meta) {
          meta = document.createElement("meta");
          meta.name = "description";
          document.head.appendChild(meta);
        }
        meta.setAttribute("content", description);
      } else {
        if (meta) {
          meta.remove();
        }
      }

      let keywordsMeta = document.querySelector<HTMLMetaElement>(
        'meta[name="keywords"]',
      );

      if (keywords) {
        if (!keywordsMeta) {
          keywordsMeta = document.createElement("meta");
          keywordsMeta.name = "keywords";
          document.head.appendChild(keywordsMeta);
        }
        keywordsMeta.setAttribute("content", keywords);
      } else if (keywordsMeta) {
        keywordsMeta.remove();
      }

      const canonicalLink = document.querySelector<HTMLLinkElement>(
        'link[rel="canonical"]',
      );

      if (canonicalLink) {
        const canonicalPath = resolveRedirectPath(url);
        canonicalLink.href = `https://www.mydecisive.ai${canonicalPath}`;
      }

      let robotsMeta = document.querySelector<HTMLMetaElement>(
        'meta[name="robots"]',
      );

      if (noIndex) {
        if (!robotsMeta) {
          robotsMeta = document.createElement("meta");
          robotsMeta.name = "robots";
          document.head.appendChild(robotsMeta);
        }
        robotsMeta.setAttribute("content", "noindex,nofollow");
      } else if (robotsMeta) {
        robotsMeta.remove();
      }
    }
  }, [url, isHydrated]);
}
